import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import BuildingsContainer from './BuildingsContainer';
import EquipTypeContainer from './EquipType/EquipTypeContainer';
import EquipLevelContainer from './Equipment/EquipLevelContainer';
import EquipSingleContainer from './EquipSingle/EquipSingleContainer';
import SensorTypeSingleContainer from './SensorTypeSingle/SensorTypeSingleContainer';
import BuildingChangelog from './changelog/BuildingChangelog';
import WithSearchParams from './WithSearchParams';
import BuildingsLoader from '../loaders/BuildingsLoader';

const ResultsRouter = () => (
  <>
    <BuildingsLoader />
    <Routes>
      <Route path="/buildings" element={<WithSearchParams component={BuildingsContainer} />} />
      <Route
        path="/buildings/:building"
        element={<WithSearchParams component={EquipTypeContainer} />}
      />
      <Route
        path="/buildings/:building/changelog"
        element={<WithSearchParams component={BuildingChangelog} />}
      />
      <Route
        path="/buildings/:building/:equipmenttype"
        element={<WithSearchParams component={EquipLevelContainer} />}
      />
      <Route
        path="/buildings/:building/:equipmenttype/asset"
        element={<WithSearchParams component={EquipSingleContainer} />}
      />
      <Route
        path="/buildings/:building/:equipmenttype/sensor"
        element={<WithSearchParams component={SensorTypeSingleContainer} />}
      />
      <Route render={() => <Navigate to="/buildings" replace />} />
    </Routes>
  </>
);

export default ResultsRouter;
